import React from 'react';

const DefaultNotFound = () => (
  <h1 className="mx-auto my-auto text-center text-3xl text-red-500 font-bold">
    Error, this page doesn&apos;t exist.

    <br />
    {' '}
    Try another one!.
  </h1>
);

export default DefaultNotFound;
